/*
 * File per la definizione dei Controller Angular:
 * https://code.angularjs.org/1.5.8/docs/guide/controller
 */
define([
    'angular',
    'file-saver'
],

    function (angular, fileSaver) {

        var richiestaAccreditamentoControllers = angular.module('richiestaAccreditamentoControllers', []);

        richiestaAccreditamentoControllers.controller('RichiestaAccreditamentoCtrl', ['$rootScope', '$scope', '$log', '$timeout', '$window', '$http', 'CONSTANTS', 'MessageService', 'ResourceService', 'FileProvider', RichiestaAccreditamentoCtrl]);

        function RichiestaAccreditamentoCtrl($rootScope, $scope, $log, $timeout, $window, $http, CONSTANTS, MessageService, ResourceService, FileProvider) {
            var vm = this;
            vm.invioClicked = false;
            vm.input = {};
            vm.annullata = false;
            vm.datiInvio = undefined;
            $rootScope.abilitaDelega = false;
            vm.inputCaptcha = "";
            vm.privacy = undefined;
            vm.radioNaturaEnte = '1';
            vm.operazione = undefined;
            //vm.datiRichiesta = undefined;

            //services
            vm.MessageService = MessageService;

            vm.actionDisabled = function () {
                if (vm.formRegistrazione.$invalid || vm.invioClicked) {
                    return true;
                }
                return false;
            }

            vm.annullaOperazione = function () {
                vm.isClean = true;
                angular.element("#modal-conferma").modal('show');
            }

            vm.annulla = function () {
                angular.element("#modal-conferma").modal('hide');
                $timeout(function () {
                    vm.input = {};
                    vm.abilitaCombo = '1';
                    $rootScope.abilitaDelega = false;
                    vm.invioClicked = false;
                    vm.privacy = undefined;
                    vm.radioNaturaEnte = '1';
                    vm.datiRichiesta = undefined;
                    vm.formRegistrazione.$setPristine();
                    MessageService.clearMessages();
                    $window.scroll(0, 0);
                }, 500);
            }

            vm.BackToRichiesta = function()
            {
                vm.invioClicked = false;
                $rootScope.abilitaDelega = false;
            }

            vm.confermaOperazione = function (operazione) {
                vm.isClean = false;
                angular.element("#modal-conferma").modal('show');
                vm.operazione = operazione;
                if(operazione == "richiesta"){
                    vm.isRichiesta = true
                    vm.isDelega = false
                }
                if(operazione == "delega"){
                    vm.isDelega = true
                    vm.isRichiesta = false
                }
            }

            vm.conferma = function () {
                angular.element("#modal-conferma").modal('hide');               
                var data = vm.input;
                data.privacy = vm.privacy;
                data.operazione = vm.operazione;
                $timeout(function () {
                    $window.scroll(0, 0);
                    MessageService.clearMessages();
                    ResourceService.invia(data, vm.inputCaptcha).then(
                        function (response) {
                            vm.abilitaCombo = '1';
                            vm.formRegistrazione.$setPristine();
                            vm.datiInvio = response.data;
                            if(vm.datiInvio.esitoDelega === '3' && vm.operazione === 'richiesta')
                            {
                                $rootScope.abilitaDelega = true;
                            }
                            if(vm.operazione === 'delega')
                            {
                                $rootScope.abilitaDelega = false;
                            }
                            vm.reloadCaptcha();
                            if(vm.datiInvio.protocolloRichiesta){
                                var message = {};
                                vm.datiInvio.cfEnte = data.codFiscEnte;
                                vm.input = {};
                                $rootScope.abilitaDelega = false;
                                message.severity = 'SUCCESS';
                                message.message = 'Operazione effettuata con successo.';
                                MessageService.setMessages([message]);
                                MessageService.showMessages();
                            }
                        }, function (response) {
                            $log.error(response);
                            if(vm.operazione === 'richiesta'){
                                $rootScope.abilitaDelega = false;
                            }else  if(vm.operazione === 'delega')
                            {
                                vm.input.fileDelga = undefined;
                            }
                            vm.reloadCaptcha();
                            response.data.messages[0].severity = 'ERROR';
                            if (response.data.messages[0].message.indexOf("link") !== -1)
                            {
                                response.data.messages[0].message = response.data.messages[0].message.replace("link=https://www.agenziaentrate.gov.it/wps/content/Nsilib/Nsi/Servizi/ServiziTrasversali/Altri/Enti+Cooperazione+informatica/Stipula+EntiCooperazioneinformatica/?page=servizitrasversali Percorso di adeguamento Accordi Vigenti","");
                                response.data.messages[0].link = {};
                                response.data.messages[0].link.href = "https://www.agenziaentrate.gov.it/wps/content/Nsilib/Nsi/Servizi/ServiziTrasversali/Altri/Enti+Cooperazione+informatica/Stipula+EntiCooperazioneinformatica/?page=servizitrasversali";
                                response.data.messages[0].link.position = "RIGHT";
                                response.data.messages[0].link.target = "_blank";
                                response.data.messages[0].link.label = "Percorso di adeguamento Accordi Vigenti";
                            } else  if (response.status == 406) {
                                response.data.messages[0].message = 'Codice Sicurezza digitato errato';
                            }
                            MessageService.setMessages(response.data.messages);
                            MessageService.showMessages();
                            
                        });
                }, 500);
            }

            vm.infoPrivacy = function () {
                var urlParams = {};
                FileProvider.openResponseInNewWindow(CONSTANTS.CONTEXT_REST_SERVICE + 'registrazione/privacy', urlParams);
            }

            vm.scaricaPDF = function () {
                MessageService.clearMessages();
                const headerDict = {
                    "X-Content-Type-Options": "nosniff",
                    "X-XSS-Protection": "1; mode=block",
                    "X-Frame-Options": "deny",
                    "Strict-Transport-Security": "max-age=16070400; includeSubDomains",
                    "Cache-Control": "no-cache,no-store, must-revalidate, pre-check=0, post-check=0"
                }
                var method = 'POST';
                var data = vm.datiInvio;
                $http({
                    url: CONSTANTS.CONTEXT_REST_SERVICE + 'registrazione/downloadRichiestaPdf?input-captcha=' + vm.inputCaptcha,
                    method: method,
                    responseType: 'arraybuffer',
                    headers: headerDict,
                    data: data
                }).then(function (result) {

                    var isJson = false;
                    try {
                        var headers = result.headers()
                        var contentType = headers['content-type'];

                        var fileNamePattern = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var fileName = fileNamePattern.exec(headers['content-disposition'])[1];

                        var blob = new Blob([result.data], { type: contentType });

                        fileSaver.saveAs(blob, fileName);

                    } catch (e) {
                        //nessuna risposta dal server
                        var msgArray = [{ severity: 'ERROR', message: 'Errore nella stampa della domanda' }];
                        MessageService.setMessages(msgArray);
                        MessageService.showMessages();
                        vm.reloadCaptcha();
                    }

                }, function error(data) {
                    $log.error(data);
                    var msgArray = [{ severity: 'ERROR', message: data.headers('msg') }];
                    MessageService.setMessages(msgArray);
                    MessageService.showMessages();
                    vm.reloadCaptcha();
                });
            }

            vm.initFn = function (loadImg) {
                vm.reloadCaptcha = loadImg;
            }
        };

        return richiestaAccreditamentoControllers;
    });


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/controllers/richiesta-accreditamento-controllers.js
// module id = 34
// module chunks = 1